import React, { Component } from 'react';
import { connect } from 'react-redux';

import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';

import DeleteIcon from '@material-ui/icons/Delete';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import DownIcon from '@material-ui/icons/KeyboardArrowDown';

import BlockHeader from './BlockHeader';
import BlockTableContents from './BlockTableContents';
import BlockTextContents from './BlockTextContents';
import Exercise from '../Exercise/Exercise';

import * as Utils from '../../../../lib//designerUtils';
import * as BlockUtils from '../../../../lib//blockUtils';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../../lib/segment/SegmentService';
import Console from '../../../../lib/debug';

export class BlockClass extends Component {
    circuitCreate() {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        let emptyExercise = {
            label: 'Circuit',
            title: 'Circuit',
            type: Utils.BlockTypes.CONDITIONING,
            plain_text: 1
        };
        DesignerState.setBlockPlainText(dispatch, block, emptyExercise);
    }
    shouldComponentUpdate(nextProps) {
        if (
            this.props.session.id === nextProps.session.id &&
            this.props.session.setKeys === nextProps.session.setKeys &&
            this.props.block === nextProps.block &&
            this.props.nextBlock === nextProps.nextBlock
        ) {
            return false;
        }

        return true;
    }
    toggleSupersetSave() {
        let block = this.props.block;
        DesignerState.toggleSupersetSaveDialog(block, true);
    }
    exportBlock() {
        let block = this.props.block;
        DesignerState.saveBlockAsSuperset(block);
    }
    enableEditing() {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.enableEditing(dispatch, block);
    }
    moveBlock(direction) {
        let session = this.props.session;
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        DesignerState.moveBlock(dispatch, session, block, direction);
        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Reorder Block Arrow icon'
        });
    }
    handleToggle() {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        let test = !this.props.block.resets_working_max;
        DesignerState.toggleTest(dispatch, block, test);
    }
    handleDelete() {
        DesignerState.deleteBlock(this.props.session, this.props.block);
    }
    toggleDeleteBlockDialog() {
        let block = this.props.block;
        let session = this.props.session;
        DesignerState.toggleDeleteBlockDialog(
            block,
            session,
            true,
            this.getBlockTypeTitle(block)
        );

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Delete Block icon'
        });
    }
    updateType(event, value) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.changeBlockType(dispatch, block, value);
    }
    updateBlockProp(prop, event, _value = null) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        let value = _value !== null ? _value : event.target.value;
        if (value !== block[prop]) {
            DesignerState.updateBlock(dispatch, block, prop, value);
        }
    }
    updateBlockTitle(_value = null) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        let value = _value;
        if (value !== block.title && value !== '') {
            DesignerState.updateBlock(dispatch, block, 'title', value);
        }
    }

    getBlockTypeTitle(block) {
        let typeTitle = 'Circuit';
        if (
            parseInt(block.plain_text) !== 1 &&
            (block.exerciseKeys.length === 1 || block.exerciseKeys.length === 0)
        ) {
            typeTitle = 'Block';
        } else if (BlockUtils.isSuperset(block)) {
            typeTitle = 'Superset';
        }
        return typeTitle;
    }

    updateExerciseType(event, value) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.changeBlockExerciseType(dispatch, block, value);
    }

    render() {
        Console.render('designer.Block');
        let dispatch = this.props.dispatch;
        let session = this.props.session;
        let block = this.props.block;
        let isLast = this.props.isLast;
        let setExercises = [];
        let videos = [];

        let elements = [];
        for (let i = 0; i < block.exerciseKeys.length; i++) {
            let exerciseKey = block.exerciseKeys[i];
            let isLastExercise = i === block.exerciseKeys.length - 1;
            elements.push(
                <Exercise
                    key={'ex' + i}
                    position={i + 1}
                    exerciseKey={exerciseKey}
                    session={session}
                    block={block}
                    isLast={isLastExercise}
                    prevBlock={this.props.prevBlock}
                    nextBlock={this.props.nextBlock}
                    dispatch={dispatch}
                />
            );
        }
        if (block.plain_text === 1) {
            videos = elements;
        } else {
            setExercises = elements;
        }
        let showDelete = BlockUtils.isSuperset(block)
            ? ' superset-options'
            : ' basic-options';
        let classes = `block block-${block.id} type-${
            block.type
        } layout-column ${showDelete} ${isLast ? 'last' : ''}`;

        let contents = null;

        if (parseInt(block.plain_text) !== 1) {
            contents = (
                <BlockTableContents
                    dispatch={dispatch}
                    classes={classes}
                    block={block}
                    session={session}
                    elements={setExercises}
                    position={1}
                    circuitCreate={this.circuitCreate.bind(this)}
                />
            );
            classes += ' block-content-tables';
        } else {
            contents = (
                <BlockTextContents
                    dispatch={dispatch}
                    classes={classes}
                    session={session}
                    block={block}
                    elements={videos}
                    position={1}
                    onBlockTitleChange={this.updateBlockTitle.bind(this)}
                    onChangeToEmptyCircuit={this.circuitCreate.bind(this)}
                />
            );
            classes += ' block-content-plain';
        }

        let position = session.setKeys.indexOf(block.key);
        let size = session.sets.length;
        let numExercises = block.exerciseKeys.length;
        let isPlainText = block.plain_text === 1;
        let buttons = [];
        let blockTypeTitle = this.getBlockTypeTitle(block);

        if (
            !Utils.isFirst(position) &&
            (Utils.hasOne(numExercises) || isPlainText)
        ) {
            let toolTip = 'Move ' + blockTypeTitle + ' Up';
            buttons.push(
                <div className="move-button previous" key="b1">
                    <Tooltip title={toolTip}>
                        <IconButton
                            className="option-button"
                            onClick={() => this.moveBlock(-1)}
                        >
                            <UpIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        } else {
            buttons.push(<div className="move-button previous" key="b1" />);
        }

        if (
            Utils.hasOne(numExercises) ||
            Utils.hasNone(numExercises) ||
            isPlainText
        ) {
            let toolTip = 'Delete ' + blockTypeTitle;
            buttons.push(
                <div className="move-button delete" key="b2">
                    <Tooltip title={toolTip}>
                        <IconButton
                            className="option-button"
                            onClick={this.toggleDeleteBlockDialog.bind(this)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }
        if (
            !Utils.isLast(position, size) &&
            (Utils.hasOne(numExercises) || isPlainText)
        ) {
            let toolTip = 'Move ' + blockTypeTitle + ' Down';
            buttons.push(
                <div className="move-button next" key="b3">
                    <Tooltip title={toolTip}>
                        <IconButton
                            className="option-button"
                            onClick={() => this.moveBlock(1)}
                        >
                            <DownIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }
        let moveButtons = <div className="move-buttons">{buttons}</div>;

        return (
            <div className={classes} ref={el => (this.blockDOMElement = el)}>
                <BlockHeader
                    block={block}
                    dispatch={this.props.dispatch}
                    onUpdateBlockProp={this.updateBlockProp.bind(this)}
                    onUpdateTitle={this.updateBlockTitle.bind(this)}
                    onUpdateType={this.updateType.bind(this)}
                    onToggleTest={this.handleToggle.bind(this)}
                    onDelete={this.toggleDeleteBlockDialog.bind(this)}
                    onToggle={this.updateBlockProp.bind(this, 'redzone_type')}
                    onBlockSave={this.toggleSupersetSave.bind(this)}
                />
                <div className="block-contents block-options-right">
                    {moveButtons}
                    {contents}
                </div>
            </div>
        );
    }
}

const mapBlockStateToProps = (state, ownProps) => {
    let nextBlock = null;
    let prevBlock = null;
    let isBlockSaved =
        state.calendar.uiTree.blockSaved.indexOf(ownProps.setKey) >= 0;

    if (ownProps.nextSetKey) {
        nextBlock = state.calendar.blockTree[ownProps.nextSetKey];
    }

    if (ownProps.prevSetKey) {
        prevBlock = state.calendar.blockTree[ownProps.prevSetKey];
    }

    return {
        block: state.calendar.blockTree[ownProps.setKey],
        nextBlock: nextBlock,
        prevBlock: prevBlock,
        isSaved: isBlockSaved,
        unlink: state.calendar.uiTree.unlink,
        ...ownProps
    };
};

export default connect(mapBlockStateToProps)(BlockClass);
